import { PARTIES, PARTY_ORDER, type GlobalAggregate } from '../lib/types';

interface Props {
  totals: GlobalAggregate['totals'];
}

const nf = new Intl.NumberFormat('sv-SE');

export function PopulationShare({ totals }: Props) {
  const total = totals.totalPopulation || 1;
  // Leading, not owning: ownership (>50 % incl. neutrals) is so rare that every
  // bar rounded to 0 %. Falls back to ownership until the cron writes the field.
  const leading = totals.populationLeadingByParty;
  const byParty = leading ?? totals.populationByParty;
  // Bars scale to the largest party so small shares stay visible; labels keep the true %.
  const maxPop = Math.max(...PARTY_ORDER.map(p => byParty[p] ?? 0), 1);

  return (
    <section className="section">
      <h2>{leading ? 'Befolkning där partiet leder' : 'Befolkning som styrs'}</h2>
      <p className="updated-at">
        {leading && 'Invånare i distrikt där partiet har flest anhängare · '}
        Totalt {nf.format(totals.totalPopulation)} invånare i spelet
      </p>
      {PARTY_ORDER.map(partyId => {
        const pop = byParty[partyId] ?? 0;
        const pct = (pop / total) * 100;
        return (
          <div className="stat-row" key={partyId}>
            <span className="label">
              <span
                className="color-dot"
                style={{ background: PARTIES[partyId].color, marginRight: 8 }}
              />
              {partyId}
            </span>
            <span className="bar-track">
              <span
                className="bar-fill"
                style={{ width: `${(pop / maxPop) * 100}%`, background: PARTIES[partyId].color }}
              />
            </span>
            <span className="value">{pct.toFixed(1)}%</span>
          </div>
        );
      })}
    </section>
  );
}
